$(document).on("click", ".new-product-content-btn", function() {
  let value=$(this).data("value")
  if($(this).hasClass("active")){
    $(this).find("span").html("Learn More")
}else{
  $(this).find("span").html("Learn Less") 
}
  $(this).toggleClass("active").parents(".common-section-container").find(".new-product-show-more-content").slideToggle('slow',function(){
    if ($(this).is(':visible')){
      if($(window).width()<850 &&  value=="flex" ){
        $(this).css('display','flex')
      }else{
        $(this).css('display','grid')
      }
      
    }
  })
});